import pb from '../lib/pocketbase';

export async function getVehiculos(page, perPage) {
  return await pb.collection('vehiculo').getList(page, perPage, {
    sort: '-created',
    $autoCancel: false
    // expand: 'propietario' // Remove or comment out this line
  });
}

export async function createVehiculo(vehiculo) {
  return await pb.collection('vehiculo').create(vehiculo);
}

export async function updateVehiculo(id, vehiculo) {
  return await pb.collection('vehiculo').update(id, vehiculo);
}

export async function deleteVehiculo(id) {
  return await pb.collection('vehiculo').delete(id);
}